import { useMemoizedFn } from 'ahooks'
import { useLingui } from '@lingui/react/macro'

import MenuCard from '../MenuCard'

import type { $Enums } from '@prisma/client'
import type { FormInstance } from 'antd'
import type { MusicGeneratorFormValuesV3 } from '@/pages/tad.ai/ai-music-generator/_types/form'

import { useGeneratorFormContext } from '@/pages/tad.ai/ai-music-generator/_blocks/GeneratorForm/_store'
import { useAppUIModal } from '@/contexts/AppUIModalContext'
import UploadAudioCard from '@/pages/tad.ai/_components/UploadAudio/UploadAudioCard'
import { getReferenceFormKeyByMusicType } from '@/pages/tad.ai/ai-music-generator/_blocks/GeneratorForm/_helpers/getReferenceFormKeyByMusicType'
import { useMusicFormStore } from '@/pages/tad.ai/ai-music-generator/_store/useMusicFormStore'


import { useState } from 'react';
import { cls } from 'tagged-classnames-free';
interface UploadMenuProps {
  form: FormInstance<MusicGeneratorFormValuesV3>
  musicType: Extract<$Enums.MusicType, 'Instrumental' | 'Song' | 'Vocal'>
}

function UploadMenu(props: UploadMenuProps) {
  const { form, musicType } = props
  const { t } = useLingui()
  const [uploading, setUploading] = useState(false)

  const setUI = useMusicFormStore((s) => s.setUI)

  const updateUploading = useMemoizedFn((value: boolean) => {
    setUploading(value)
    setUI({ isUploading: value })
  })

  const { editAudioModal, hasActivePlan } = useGeneratorFormContext()
  const setFormValues = useMusicFormStore((s) => s.setFormValues)

  const { upgradePlan } = useAppUIModal()

  const handleWrapClick = (e: React.MouseEvent) => {
    if (uploading) {
      e.stopPropagation()
      e.preventDefault()
      return
    }
    if (!hasActivePlan) {
      e.stopPropagation()
      e.preventDefault()
      upgradePlan.show()
    }
  }

  return (
    <div onClickCapture={handleWrapClick}>
      <UploadAudioCard
        onBeforeUpload={() => {
          updateUploading(false)
        }}
        onUploadError={() => {
          updateUploading(false)
        }}
        onUploading={() => {
          updateUploading(true)
        }}
        onUploadSuccess={({ url, filename }) => {
          setUploading(false)
          editAudioModal.show({
            musicModel: form.getFieldValue('model'),
            musicType,
            filename,
            file: url,
            onSuccess: ({ token, filename }) => {
              const formName = getReferenceFormKeyByMusicType(musicType)
              form.setFieldValue(formName as keyof MusicGeneratorFormValuesV3, {
                token,
                filename,
              })
              setFormValues({
                [formName]: { token, filename },
              })
              setUI({ isUploading: false })
              editAudioModal.close()
            },
          })
        }}
      >
        <MenuCard
          icon={cls`i-cus--tad-upload-02`}
          label={t`Upload Audio`}
          premium
          loading={uploading}
        />
      </UploadAudioCard>
    </div>
  )
}

export default UploadMenu
